import { Card, Flex, Icon, Space, Text } from "components/common"
import { TitleDescription } from "components/custom"
import { DubizzleFireIcon } from "components/svg"
import theme from "utils/themeVars"
import styles from "../index.module.less"
import { t } from "i18next"
import { BsFillStopwatchFill } from "react-icons/bs"
import cx from "clsx"

const cardData = (soldCount, availableCount) => {
  if (soldCount <= 2) {
    return {
      title: t("Early Price Advantage"),
      desc: t("Best time to buy before the prices move up"),
      color: "#EDF8F0",
      icon: <BsFillStopwatchFill style={{ color: theme["primary-color"] }} size={18} />,
    }
  } else if (soldCount > 2 && availableCount >= 1) {
    return {
      title: t("Selling Quickly"),
      desc: (
        <>
          {t("Inventory is running out")},{" "}
          <span style={{ color: "#FF8F00" }}>{t("only {{count}} units left", { count: availableCount })}</span>
        </>
      ),
      color: "#FF8F001A",
      icon: <DubizzleFireIcon color={"#FF8F00"} size={18} />,
    }
  } else return false
}

const UnitsSoldCard = ({ project }) => {
  const detailCardData = cardData(project?.soldUnitsCount, project?.availableUnitsCount)
  return (
    <Card className={styles.unitsSoldCard} bordered={false} bodyStyle={{ padding: "12px 16px" }}>
      <Space size={12} gap={4}>
        <div className={styles.unitsSoldIconContainer} style={{ "background-color": detailCardData?.color }}>
          {detailCardData?.icon}
        </div>
        <div>
          <TitleDescription
            title={detailCardData?.title}
            description={<Text color={theme["gray900"]}>{detailCardData?.desc}</Text>}
            titleStyle={{ color: theme["base-color"] }}
            titleClassName="bold"
            gapSpace={2}
          />
        </div>
      </Space>
    </Card>
  )
}

export default UnitsSoldCard
